export default __webpack_public_path__ + "static/media/Relic of the Oyster Mucus.16fa1486.jpg";